import { SYNC_REQUEST_TYPE } from '../../enums/sync-request-type.enum';

export class SyncRequestModel {
    public constructor(
        public syncRequestType: SYNC_REQUEST_TYPE,
        public triggerSyncEvent: boolean,
    ) {}

    public toString(): string {
        let type = 'REFRESH_ALL';
        if (this.syncRequestType === SYNC_REQUEST_TYPE.REFRESH_NOTIFICATIONS) {
            type = 'REFRESH_NOTIFICATIONS';
        }
        if (this.syncRequestType === SYNC_REQUEST_TYPE.REFRESH_WHATSNEW) {
            type = 'REFRESH_WHATSNEW';
        }
        if (this.syncRequestType === SYNC_REQUEST_TYPE.REFRESH_BOOTSTOCK) {
            type = 'REFRESH_BOOTSTOCK';
        }
        if (this.syncRequestType === SYNC_REQUEST_TYPE.FLUSH_ONLY) {
            type = 'FLUSH_ONLY';
        }
        if (this.syncRequestType === SYNC_REQUEST_TYPE.FLUSH_AND_REFRESH_NOTIFICATIONS_AND_BOOTSTOCK) {
            type = 'FLUSH_AND_REFRESH_NOTIFICATIONS_AND_BOOTSTOCK';
        }
        return '[' + type + '|triggerEvent:' + (this.triggerSyncEvent ? 'true' : 'false') + ']';
    }
}
